export const findStatusFromNumericVal = (val) => {
  switch (val) {
    case 2:
      return "ACTIVE";
    case 3:
      return "INACTIVE";
    case 4:
      return "PENDING";
    default:
      return null;
  }
};

export const findPlanFromNumericVal = (val) => {
  switch (val) {
    case 2:
      return "free";
    case 3:
      return "premium";
    case 4:
      return "trial";
    default:
      return null;
  }
};
